var map = {
	"./30-times-color-icon.svg": 4401,
	"./404-not-found.svg": 6758,
	"./SRX-logo-with-text.svg": 3219,
	"./about-us-icon.svg": 7967,
	"./adjust-icon.svg": 9264,
	"./alert-expired-inventory-icon.svg": 2786,
	"./alert-expiring-inventory-icon.svg": 767,
	"./alert-recalled-inventory-icon.svg": 7683,
	"./angle-down.svg": 677,
	"./api-msg-icon.svg": 1505,
	"./area-chart-img.svg": 9017,
	"./area_chart_icon.svg": 4927,
	"./athena-trans-icon.svg": 1767,
	"./bar-chart-img.svg": 391,
	"./bar-chart-placeholder.svg": 9449,
	"./calender-icon.svg": 4889,
	"./chevrons-left.svg": 3499,
	"./chevrons-right.svg": 2686,
	"./circle-check-icon.svg": 7834,
	"./contact-us-icon.svg": 8820,
	"./count-icon.svg": 2178,
	"./dash-expired-inventory-value.svg": 416,
	"./dash-home.svg": 1521,
	"./dash-inventory-value.svg": 4492,
	"./dash-location.svg": 4929,
	"./dash-no-items.svg": 7042,
	"./dash-user.svg": 7765,
	"./dashboard.svg": 5501,
	"./date-expired-icon.svg": 8135,
	"./deactivate-icon.svg": 1849,
	"./default-icon.svg": 2640,
	"./delete-icon.svg": 7348,
	"./delete-item-modal-image.svg": 6754,
	"./delete-user-modal-image.svg": 94,
	"./detail-icon.svg": 3514,
	"./donut-chart-img.svg": 6576,
	"./donut-chart-img2.svg": 114,
	"./download-icon.svg": 8723,
	"./duplicate-icon.svg": 4800,
	"./duplicate-item-modal-image.svg": 1710,
	"./duplicate-plus-icon.svg": 1075,
	"./edit-icon.svg": 4315,
	"./excel-icon.svg": 2614,
	"./expired-inventory-icon.svg": 3429,
	"./export-icon.svg": 4705,
	"./faq-icon.svg": 9025,
	"./filter-icon.svg": 1245,
	"./forcast-icon.svg": 3077,
	"./icon_filter.svg": 6449,
	"./import-icon.svg": 1554,
	"./inventory-order-icon.svg": 6896,
	"./inventory-status-icon.svg": 7406,
	"./inventory.svg": 505,
	"./inventry.svg": 7288,
	"./item-type-icon2.svg": 7611,
	"./item-type-icon3.svg": 8554,
	"./item-type-icon4.svg": 181,
	"./item-type-master-icon.svg": 1188,
	"./item-warning-icon.svg": 553,
	"./load-icon.svg": 1811,
	"./location-master-icon-2.svg": 1756,
	"./location-master-icon.svg": 5597,
	"./login-logo.svg": 3002,
	"./logo-text.svg": 454,
	"./logo-text2.svg": 5432,
	"./logo.svg": 3914,
	"./mark-complete-modal-image.svg": 9308,
	"./not-allowed.svg": 8717,
	"./not-found.svg": 2337,
	"./notification-bell.svg": 2528,
	"./ordering-product-icon.svg": 8625,
	"./pass-reset-succes-image.svg": 1701,
	"./patient-master-icon.svg": 1317,
	"./pdf-icon.svg": 7423,
	"./permission-icon.svg": 9868,
	"./pie-chart-placeholder.svg": 8552,
	"./play.svg": 5789,
	"./prediction-icon.svg": 7666,
	"./print-icon.svg": 710,
	"./product-master-icon.svg": 515,
	"./product-recalled.svg": 1945,
	"./product-replacement-icon.svg": 4239,
	"./question-mark.svg": 7463,
	"./receive-icon.svg": 9332,
	"./receiving-details-icon.svg": 9744,
	"./records.svg": 2747,
	"./refresh-icon.svg": 3098,
	"./repack-icon.svg": 59,
	"./report-icon.svg": 5833,
	"./reset-password-icon.svg": 2432,
	"./sF-logo.svg": 4400,
	"./search.svg": 1599,
	"./setting-icon.svg": 3713,
	"./status-modal-image.svg": 9717,
	"./stock-mater-icon.svg": 6215,
	"./stop-circle.svg": 128,
	"./stop.svg": 3027,
	"./thermometer-icon.svg": 8357,
	"./three-dots-horizontal.svg": 2571,
	"./three-dots-vertical.svg": 8881,
	"./tickets-icon.svg": 5900,
	"./times-icon.svg": 2951,
	"./transfer-details-report-icon.svg": 840,
	"./transfer-icon.svg": 6096,
	"./unit-mater-icon.svg": 3201,
	"./unprocessed-icon.svg": 2392,
	"./upload-file-icon.svg": 9847,
	"./usage-detail-report-icon.svg": 7189,
	"./usage-transactions-icon.svg": 4536,
	"./user.svg": 4514,
	"./userguide-icon.svg": 2884,
	"./users.svg": 6477,
	"./vendor-master-icon.svg": 9022,
	"./view-icon.svg": 7750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7659;